module.exports = __webpack_public_path__ + "img/lea-43.25a6b5a4.png";